// PostHog rejects a set of sentinel "illegal" distinct_ids — values that are
// almost always a default/placeholder/bug rather than a real user. Trying to
// identify as, or merge an anonymous person into, one of these (e.g. "0") is
// rejected server-side with `cannot_merge_with_illegal_distinct_id` and the
// identify is lost.
//
// Our auth `uid` is normally a positive integer, but a malformed/default auth
// payload can surface the string "0" — which is TRUTHY, so a plain `if (!uid)`
// guard lets it through. This predicate rejects the empty/sentinel cases so we
// never bootstrap or identify with an illegal id.
//
// Shared canonical source for both the client (PostHogProvider bootstrap +
// identify) and the server bootstrap middleware
// (lib/server/posthog-bootstrap/middleware.js). Kept dependency-free so the SWC
// server build can compile and import it (lib/**/*.ts -> dist/server/lib/**/*.js).
const ILLEGAL_DISTINCT_IDS = new Set([
  '0',
  'anonymous',
  'guest',
  'none',
  'null',
  'undefined',
  'true',
  'false',
  'nan',
  '[object object]',
  'distinct_id',
  'distinctid',
])

export default function isValidDistinctId (uid: unknown): boolean {
  if (uid == null) return false
  const normalized = String(uid).trim().toLowerCase()
  return normalized !== '' && !ILLEGAL_DISTINCT_IDS.has(normalized)
}
